import React, { useState } from 'react';
import './ClaimsDelegateDialog.scss';

function ClaimsDelegateDialog() {
  const [selected, setSelected] = useState('myself');

  const options = [
    {
      id: 'lighthouse',
      title: 'Lighthouse Storage',
      subtitle: 'Development Company',
    },
    {
      id: 'other',
      title: 'Other',
      subtitle: 'I want someone else to vote on my behalf',
    },
    {
      id: 'myself',
      title: 'Myself',
      subtitle: 'I want to vote myself',
    }
  ];

  return (
    <div className="delegate-dialog">
      <div className="dialog-header">
        <h2>Choose a delegate</h2>
        <p>Select a governance delegate to vote on your behalf, or self delegate. You can change it anytime.</p>
      </div>
      <div className="delegate-options">
        {options.map(option => (
          <div
            key={option.id}
            className={`option ${selected === option.id ? 'selected' : ''}`}
            onClick={() => setSelected(option.id)}
          >
            <div>
              <h3>{option.title}</h3>
              <p>{option.subtitle}</p>
            </div>
            <div className="radio">
              <div className="outer">
                {selected === option.id && <div className="inner" />}
              </div>
            </div>
          </div>
        ))}
      </div>
      <button className="fillBtn__blue" style={{ margin: '0px', marginTop:'1rem' , width:'100%' }}>NEXT</button>
    </div>
  );
}

export default ClaimsDelegateDialog;